export default __webpack_public_path__ + "static/media/ARIALBD 1.64dde1b4.TTF";